<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>
      {{'Buscar por ' | translate}} {{tipo == 1 ? ('grupo' | nomenclatura | async) : ('ministerio' | nomenclatura |
      async)}}
    </ion-title>

    <ion-col class="end-filter">
      <div (click)="filtrar()">
        <i class="fa fa-filter"></i>
      </div>
    </ion-col>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido">
    <ion-searchbar
      show-cancel-button="never"
      class="custom"
      (ionCancel)="onCancel()"
      placeholder="{{'Buscar' | translate}}"
      [(ngModel)]="filtro"
      (ionInput)="onInput()"
    >
    </ion-searchbar>
  </div>

  <ion-grid>
    <ion-row style="border-bottom: none !important">
      <ion-col size="4" *ngIf="tipoGrupo">
        <ion-chip class="text-chip">
          <ion-label class="text-chip">{{nomeTipoGrupo}}</ion-label>

          <i class="fa-regular fa-xmark-large chip-close-icon" (click)="removerFiltro('tipo')"></i>
        </ion-chip>
      </ion-col>

      <ion-col size="4" *ngIf="dia">
        <ion-chip class="text-chip">
          <ion-label class="text-chip">{{getNomeDia(dia)}}</ion-label>

          <i class="fa-regular fa-xmark-large chip-close-icon" (click)="removerFiltro('dia')"></i>
        </ion-chip>
      </ion-col>

      <ion-col size="4" *ngIf="nomeRegiao">
        <ion-chip class="text-chip">
          <ion-label>{{nomeRegiao}}</ion-label>

          <i class="fa-regular fa-xmark-large chip-close-icon" (click)="removerFiltro('regiao')"></i>
        </ion-chip>
      </ion-col>
    </ion-row>

    <ion-row *ngFor="let g of grupoList">
      <ion-col class="remove-border">
        <ion-item (click)="selecionarGrupo(g.id)">
          <ion-note slot="start">
            <i class="fas fa-users icon-list"></i>
          </ion-note>

          <ion-label>
            <h3>{{ g.nome }}</h3>

            <p>{{g.grupoTipo}}</p>
          </ion-label>

          <ion-note slot="end">
            <i class="fa-solid fa-chevron-right icon-list"></i>
          </ion-note>
        </ion-item>
      </ion-col>
    </ion-row>

    <ion-infinite-scroll (ionInfinite)="loadGrupos($event)" *ngIf="pagination.currentPage < pagination.pageCount">
      <ion-infinite-scroll-content loadingText="{{'Carregando' | translate}}..."> </ion-infinite-scroll-content>
    </ion-infinite-scroll>

    <sem-registro [hidden]="grupoList.length"> </sem-registro>
  </ion-grid>
</ion-content>
